import { useState, useCallback, useEffect } from "react";
import { useLocation } from "react-router-dom";
import DocViewer, { DocViewerRenderers } from "@cyntler/react-doc-viewer";
import Paper from "@mui/material/Paper";
import FormHeader from "../Form/FormHeader";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import AgreementStatus from "./AgreementStatus";
import { getAgreement } from "../../services/agreementServices";
import SignerList from "./SignerList";
import { getAgreementAnalyze } from "../../services/agreementServices";
import CoordinatorList from "./CoordinatorList";
import IndicatorList from "./IndicatorList";
import IndicatorStatus from "./IndicatorStatus";

export default function AgreementIndicatorEdit() {
  const { search } = useLocation();
  const queryParams = new URLSearchParams(search);
  const id = queryParams.get("id");

  const [agreement, setAgreement] = useState([]);
  const [signers, setSigners] = useState([]);
  const [report, setReport] = useState([]);
  const [indicators, setIndicators] = useState([]);
  const [agreementId, setAgreementId] = useState("");
  const [agreementStatus, setAgreementStatus] = useState("");

  const onHandleIndicatorList = (indicators) => {
    
    setIndicators(indicators);
    
  };

  const agreementData = useCallback(async () => {
    try {
      const response = await getAgreement(`/api/v1/agreements/${id}`);
      setAgreement(response.data);
      setSigners(JSON.parse(response.data.signers));
      setAgreementId(response.data.id);
      
      setAgreementStatus(response.data.status);
    } catch (err) {
      if (!err?.response) {
        
      }
    }
  }, []);
  const reportData = useCallback(async () => {
    try {
      const response = await getAgreementAnalyze(id);
      
      setReport(response.data);
      setIndicators(response.data.indicators);
      
    } catch (err) {
      if (!err?.response) {
        
      }
    }
  }, []);

  useEffect(() => {
    agreementData();
    reportData();
  }, []);
  return (
    <Paper elevation={2} sx={{ padding: 5 }}>
      <FormHeader title="Editar indicadores del convenio" />
      <Paper elevation={2} sx={{ padding: 5 }}>
        <Grid container direction="row" sx={{ padding: 5 }}>
          <Grid item xs={6}>
            <Grid container direction="row">
              <Typography variant="subtitle2" gutterBottom>
                Estado:
              </Typography>

              <AgreementStatus currentStatus={agreementStatus} />
            </Grid>
          </Grid>
          <Grid item xs={6}>
            <Grid container direction="row">
              <Typography variant="subtitle2" gutterBottom>
                Creado por:
              </Typography>

              <Typography variant="body2" gutterBottom>
                {agreement.user_id}
              </Typography>
            </Grid>
          </Grid>
          <Grid item xs={6}>
            <Grid container direction="row">
              <Typography variant="subtitle2" gutterBottom>
                Nº de orden:
              </Typography>

              <Typography variant="body2" gutterBottom>
                {agreement.order_number}
              </Typography>
            </Grid>
          </Grid>

          <Grid item xs={6}>
            <Grid container direction="row">
              <Typography variant="subtitle2" gutterBottom>
                Tipo de convenio:
              </Typography>

              <Typography variant="body2" gutterBottom>
                {agreement.agreement_type}
              </Typography>
            </Grid>
          </Grid>

          <Grid item xs={6}>
            <Grid container direction="row">
              <Typography variant="subtitle2" gutterBottom>
                Objetivo:
              </Typography>
              <Typography variant="body2" gutterBottom>
                {agreement.objective}
              </Typography>
            </Grid>
          </Grid>

          <Grid item xs={6}>
            <Grid container direction="row">
              <Typography variant="subtitle2" gutterBottom>
                Institución Co-celebrante:
              </Typography>
              <Typography variant="body2" gutterBottom>
                {agreement.entity}
              </Typography>
            </Grid>
          </Grid>

          <Grid item xs={6}>
            <Grid container direction="row">
              <Typography variant="subtitle2" gutterBottom>
                Nº de resolución:
              </Typography>
              <Typography variant="body2" gutterBottom>
                {agreement.resolution_number}
              </Typography>
            </Grid>
          </Grid>

          <Grid item xs={6}>
            <Grid container direction="row">
              <Typography variant="subtitle2" gutterBottom>
                Fecha de suscripción:
              </Typography>

              <Typography variant="body2" gutterBottom>
                {agreement.suscription_date}
              </Typography>
            </Grid>
          </Grid>

          <Grid item xs={6}>
            <Grid container direction="row">
              <Typography variant="subtitle2" gutterBottom>
                Fecha de vigencia:
              </Typography>
              <Typography variant="body2" gutterBottom>
                {agreement.effective_date}
              </Typography>
            </Grid>
          </Grid>

          <Grid item xs={6}>
            <Grid container direction="row">
              <Typography variant="subtitle2" gutterBottom>
                Firmantes:
              </Typography>
            </Grid>
            <SignerList signers={signers} />
          </Grid>

          <Grid item xs={6}>
            <Grid container direction="row">
              <Typography variant="subtitle2" gutterBottom>
                Archivos adjuntados:
              </Typography>

              {agreement.images && (
                <DocViewer
                  documents={agreement.images}
                  pluginRenderers={DocViewerRenderers}
                  style={{ height: 400, width: 400 }}
                />
              )}
            </Grid>
          </Grid>
        </Grid>
        <Grid container direction="row" sx={{ padding: 5 }} spacing={2}>
          <Grid item xs={6}>
            <Grid container direction="row" spacing={2}>
              <Typography variant="subtitle2" gutterBottom>
                Unidad académica:
              </Typography>

              <Typography variant="body2" gutterBottom>
                {report.academic_unit}
              </Typography>
            </Grid>
          </Grid>

          <Grid item xs={6}>
            <Grid container direction="row" spacing={2}>
              <Typography variant="subtitle2" gutterBottom>
                Carrera:
              </Typography>

              <Typography variant="body2" gutterBottom>
                {report.career}
              </Typography>
            </Grid>
          </Grid>

          <Grid item xs={6}>
            <Grid container direction="row" spacing={2}>
              <Typography variant="subtitle2" gutterBottom>
                Coordinador/es designado/s:
              </Typography>

              <CoordinatorList coordinators={report.coordinators} />
            </Grid>
          </Grid>

          <Grid item xs={6}>
            <Grid container direction="row" spacing={2}>
              <Typography variant="subtitle2" gutterBottom>
                Celebrado a propuesta de:
              </Typography>

              <Typography variant="body2" gutterBottom>
                {report.proposal}
              </Typography>
            </Grid>
          </Grid>

          <Grid item xs={6}>
            <Grid container direction="row" spacing={2}>
              <Typography variant="subtitle2" gutterBottom>
                Período evaluado:
              </Typography>

              <Typography variant="body2" gutterBottom>
                {report.evaluated_period}
              </Typography>
            </Grid>
          </Grid>

          <Grid item xs={6}>
            <Grid container direction="row" spacing={2}>
              <Typography variant="subtitle2" gutterBottom>
                Dependencia evaluadora:
              </Typography>

              <Typography variant="body2" gutterBottom>
                {report.evaluation_unit}
              </Typography>
            </Grid>
          </Grid>

          <Grid item xs={6}>
            <Grid container direction="row" spacing={2}>
              <Typography variant="subtitle2" gutterBottom>
                Fecha de presentación:
              </Typography>

              <Typography variant="body2" gutterBottom>
                {report.presentation_date}
              </Typography>
            </Grid>
          </Grid>

          <Grid item xs={6}>
            <Grid container direction="row" spacing={2}>
              <Typography variant="subtitle2" gutterBottom>
                Observación:
              </Typography>

              <Typography variant="body2" gutterBottom>
                {report.observation}
              </Typography>
            </Grid>
          </Grid>

          <Grid item xs={12} sx={{ paddingBottom: 5 }}>
            {indicators && agreementId && (
              <IndicatorList
                id={agreementId}
                indicators={indicators}
                showButtons={false}
                setIndicators={onHandleIndicatorList}
                showUpdateStatus={true}
                setAgreementStatus={agreementData}
              />
            )}
          </Grid>
        </Grid>
      </Paper>
    </Paper>
  );
}
